import axios from 'http.service';
import apiErrorMsg from 'Common/Utils/apiErrorMsg';

const baseUrl = '/api/v2/appointments';

const fetchReadyAppointments = async (year, grouping, errorCb) => {
	const groupingEncoded = encodeURIComponent(grouping);
	const query = new URLSearchParams();
	query.append('issued', true);
    query.append('readyForApproval', 'Ready');
	const url = `${baseUrl}/appointments/${year}/${groupingEncoded}?${query.toString()}`;
	const {
		status,
		data: {	data: appointments, errors }
	} = await axios.get(url);
	if (status === 200) {
		return appointments;
	}
	const errorMessage = apiErrorMsg(status, errors);
	return errorCb(errorMessage);
};

export { fetchReadyAppointments };
